import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { useTheme } from 'styled-components'

import { Markdown } from '@/@bothrs-ui/web/components/markdown/Markdown'

import type { FC } from 'react'

type AdminMessageCardProps = {
  message: string
}

const AdminMessageCard: FC<AdminMessageCardProps> = ({ message }) => {
  const theme = useTheme()

  return (
    <StCardContainer>
      <StIconWrapper>
        <FontAwesomeIcon icon={['fal', 'circle-info']} size='lg' color={theme.Colors.Neutrals.Darkest} />
      </StIconWrapper>
      <StMarkdownWrapper>
        <Markdown content={message} typography='BodyMediumRegular' />
      </StMarkdownWrapper>
    </StCardContainer>
  )
}

export { AdminMessageCard }

const StCardContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.UI.Spacing.Space3}px;
  align-items: flex-start;
  padding: ${({ theme }) => theme.UI.Spacing.Space5}px;
  background: ${({ theme }) => theme.Colors.Background.White};
  border: 1px solid ${({ theme }) => theme.Colors.Neutrals.Light};
  border-radius: 12px;
`

const StIconWrapper = styled.div`
  flex-shrink: 0;
  padding-top: 3px;
`

const StMarkdownWrapper = styled.div`
  min-width: 0;
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};

  strong {
    color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
  }

  p:last-child {
    margin-bottom: 0;
  }
`
